import { render, staticRenderFns } from "./OtherFeatures.vue?vue&type=template&id=5f1654ea&scoped=true&lang=pug&"
import script from "./OtherFeatures.vue?vue&type=script&lang=js&"
export * from "./OtherFeatures.vue?vue&type=script&lang=js&"
import style0 from "./OtherFeatures.vue?vue&type=style&index=0&id=5f1654ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1654ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VImg,VRow})
